
import React, { useState } from "react"
// import { breakpoints } from "../../utils"
import Modal from "./modal"
const Enquirypopup = () => {
    const [modalOpen, setModalOpen] = useState(false)
    const toggleModal = () => {
        setModalOpen(!modalOpen)
    }
    return (
        <div className="configurator__specify">
            <Modal isOpen={modalOpen} toggleModal={toggleModal} />
            <a className="enquiry-open btn btn--icon" onClick={toggleModal}>
                Enquire Now
                <svg><use xlinkHref="#arrow-up" /></svg>
            </a>
        </div>
    )
}
export default Enquirypopup